import { AIConversationsState } from 'slices/aiConversations/types'

export const initialAIConversationsState: AIConversationsState = {
  activeConversation: null,
  webSocket: {
    connectionStatus: 'disconnected',
    connectionError: null,
    isProcessing: false,
    managerId: null,
    currentStreamingMessage: null,
    awaitingResponse: false,
    isLoading: false,
    chatId: null,
  },
}
